<ion-header>
	<ion-toolbar>
		<ion-buttons slot="secondary">
			<ion-button (click)="dismiss()"> Tillbaka </ion-button>
		</ion-buttons>
		<ion-title>Lägg till Medalj</ion-title>
		<ion-buttons slot="end">
			<ion-button
				(click)="save()"
				[disabled]="!(player.firstName && year && event && value) || (isTeam && !comment)"
			>
				Spara
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
<ion-content>
	<ion-list>
		<ion-segment
			[(ngModel)]="championshipType"
			(ngModelChange)="setDefaultValue()"
			[color]="championshipType == 'SM' ? 'secondary' : (championshipType == 'EM' ? 'primary' : (championshipType == 'VM' ? 'danger' : 'warning'))"
		>
			<ion-segment-button value="SM">
				<ion-label>SM</ion-label>
				@if (championshipType == 'SM') {
				<ion-icon color="success" name="sweden" />
				} @else {
				<ion-icon name="sweden-outline" />
				}
			</ion-segment-button>
			<ion-segment-button value="EM">
				<ion-label>EM</ion-label>
				@if (championshipType == 'EM') {
				<ion-icon color="primary" name="europe" />
				} @else {
				<ion-icon name="europe-outline" />
				}
			</ion-segment-button>
			<ion-segment-button value="VM">
				<ion-label>VM</ion-label>
				@if(championshipType == 'VM') {
				<ion-icon name="earth" color="danger" />
				} @else {
				<ion-icon name="earth-outline" />
				}
			</ion-segment-button>
			<ion-segment-button value="OS">
				<ion-label>OS</ion-label>
				@if(championshipType == 'OS') {
				<ion-icon name="os" />
				} @else {
				<ion-icon name="os-outline" />
				}
			</ion-segment-button>
		</ion-segment>
		<ion-segment
			class="values"
			[(ngModel)]="value"
			[ngClass]="{gold: value == 'GULD', silver: value == 'SILVER', bronze: value == 'BRONS'}"
		>
			<ion-segment-button value="GULD">
				<ion-label>GULD</ion-label>
				@if (value == 'GULD') {
				<ion-icon color="gold" name="medal" />
				} @else {
				<ion-icon name="medal-outline" />
				}
			</ion-segment-button>
			<ion-segment-button value="SILVER" [disabled]="championshipType === 'SM'">
				<ion-label>SILVER</ion-label>
				@if (value == 'SILVER') {
				<ion-icon color="silver" name="medal" />
				} @else {
				<ion-icon name="medal-outline" />
				}
			</ion-segment-button>
			<ion-segment-button value="BRONS" [disabled]="championshipType === 'SM'">
				<ion-label>BRONS</ion-label>
				@if (value == 'BRONS') {
				<ion-icon color="bronze" name="medal" />
				} @else {
				<ion-icon name="medal-outline" />
				}
			</ion-segment-button>
		</ion-segment>
		<ion-item lines="full">
			<ion-icon slot="start" name="calendar-number" />
			<ion-input placeholder="Årtal" type="number" [(ngModel)]="year" min="1931" max="2050"></ion-input>
		</ion-item>

		<ion-item lines="full" button [detail]="!event" id="select-event" (click)="scroll()">
			<ion-icon slot="start" name="male-female" />
			<ion-input placeholder="Klass" [(ngModel)]="event"></ion-input>
		</ion-item>

		<ion-item lines="full">
			<ion-icon slot="start" name="text" />
			<ion-textarea placeholder="Kommentar" [(ngModel)]="comment"></ion-textarea>
		</ion-item>
		@if (!player.firstName) {
		<ion-item disabled="true" lines="full">
			<ion-label>Välj spelare</ion-label>
		</ion-item>
		} @else {
		<ion-item lines="full" (click)="clearPlayer()">
			@if (player.isFemale) {
			<ion-icon slot="start" name="female" color="danger" />
			} @else {
			<ion-icon slot="start" name="male" color="primary" />
			}
			<ion-label>
				<h3>{{player.firstName}} <strong>{{player.lastName}}</strong></h3>
				<p>{{player.club.clubName}} ({{player.ranking}})</p>
			</ion-label>
			<ion-chip slot="end" color="dark">
				<ion-label> {{ player.age }} ({{ player.ageClass }}) </ion-label>
			</ion-chip>
		</ion-item>
		} @if (isDouble && !partner.firstName) {
		<ion-item disabled="true" lines="full">
			<ion-label>Välj partner</ion-label>
		</ion-item>
		} @if (partner.firstName) {

		<ion-item lines="full" (click)="clearPartner()">
			@if (partner.isFemale) {
			<ion-icon slot="start" name="female" color="danger" />
			} @else {
			<ion-icon slot="start" name="male" color="primary" />
			}
			<ion-label>
				<h3>{{partner.firstName}} <strong>{{partner.lastName}}</strong></h3>
				<p>{{partner.club.clubName}} ({{partner.ranking}})</p>
			</ion-label>
			<ion-chip slot="end" color="dark">
				<ion-label> {{ partner.age }} ({{ partner.ageClass }}) </ion-label>
			</ion-chip>
		</ion-item>
		} @if (isTeam) { @for (p of selectedPlayers; track $index; let i = $index) {
		<ion-item lines="full" (click)="removePlayer(i)">
			@if (p.isFemale) {
			<ion-icon slot="start" name="female" color="danger" />
			} @else {
			<ion-icon slot="start" name="male" color="primary" />
			}
			<ion-label>
				<h3>{{p.firstName}} <strong>{{p.lastName}}</strong></h3>
				<p>{{p.club.clubName}} ({{p.ranking}})</p>
			</ion-label>
			<ion-chip slot="end" color="dark">
				<ion-label> {{ p.age }} ({{ p.ageClass }}) </ion-label>
			</ion-chip>
		</ion-item>
		} @if (!selectedPlayers.length) {
		<ion-item disabled="true" lines="full">
			<ion-label>Välj lagmedlemmar</ion-label>
		</ion-item>
		} }
	</ion-list>
	@if (!player.firstName || (isDouble && !partner.firstName) || isTeam) {

	<h3 class="ion-text-center">Sök spelare</h3>
	<ion-grid class="searchFields">
		<ion-row>
			<ion-col size="4">
				<ion-searchbar
					class="searchField"
					placeholder="Förnamn"
					[(ngModel)]="filterModel.firstName"
					(ngModelChange)="getPlayers()"
				></ion-searchbar>
			</ion-col>
			<ion-col size="4">
				<ion-searchbar
					class="searchField"
					placeholder="Efternamn"
					[(ngModel)]="filterModel.lastName"
					(ngModelChange)="getPlayers()"
				></ion-searchbar>
			</ion-col>
			<ion-col size="4">
				<ion-searchbar
					class="searchField"
					placeholder="Klubb"
					[(ngModel)]="filterModel.club"
					(ngModelChange)="getPlayers()"
				></ion-searchbar>
			</ion-col>
		</ion-row>
	</ion-grid>
	@if (showLoading) {
	<div class="ion-text-center">
		<br />
		<ion-spinner></ion-spinner>
	</div>
	} @if (players.length) {
	<ion-list lines="full">
		@for (p of players; track $index) { @if (p.playerId !== player.playerId && p.playerId !== partner.playerId &&
		playerNotInList(p)) {

		<ion-item class="players" (click)="selectPlayer(p)">
			<player-avatar slot="start" [player]="p"></player-avatar>
			<ion-label>
				<h3>{{ p.firstName }} <strong>{{ p.lastName }}</strong></h3>
				<p>
					{{ p.club.clubName }} @if (p.isFemale) {
					<ion-icon size="small" name="female" color="danger" />
					} @else {
					<ion-icon size="small" name="male" color="primary" />
					} ({{ p.ranking }})
				</p>
			</ion-label>
			<ion-chip slot="end">
				<ion-label> {{ p.age }} ({{ p.ageClass }}) </ion-label>
			</ion-chip>
		</ion-item>
		} }
	</ion-list>
	}
	<ion-infinite-scroll threshold="100px" (ionInfinite)="loadData($event)">
		<ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Hämtar spelare ...">
		</ion-infinite-scroll-content>
	</ion-infinite-scroll>
	<ion-fab horizontal="end" vertical="bottom" slot="fixed">
		<ion-fab-button color="dark" (click)="scrollToTop()">
			<ion-icon name="chevron-up-circle-outline" />
		</ion-fab-button>
	</ion-fab>
	}
</ion-content>

<ion-modal trigger="select-event" (ionModalDidPresent)="onModalPresented($event)" #modal>
	<ng-template>
		<ion-header>
			<ion-toolbar>
				<ion-buttons slot="start">
					<ion-button (click)="modal.dismiss()">Avbryt</ion-button>
				</ion-buttons>
				<ion-title>Välj klass</ion-title>
			</ion-toolbar>
			<ion-toolbar>
				<ion-searchbar placeholder="Sök klass" (ionInput)="onSearchbarInputChange($event)"></ion-searchbar>
			</ion-toolbar>
		</ion-header>

		<ion-content>
			<ion-list>
				@for (e of events; track $index) {

				<ion-item-group>
					<ion-item-divider>
						<ion-label>{{e.name}}</ion-label>
					</ion-item-divider>
					@for (i of e.items; track $index) {

					<ion-item
						(click)="eventSelected(i)"
						class="eventItem"
						[class.selected]="i === event"
						[color]="i === event ? 'medium' : ''"
					>
						<ion-label>{{i}}</ion-label>
						@if (isMixed(i)) {
						<ion-icon slot="end" name="male-female" />
						} @else if (isFemale(i)) {
						<ion-icon slot="end" name="female" color="danger" />
						} @else {
						<ion-icon slot="end" name="male" color="primary" />
						}
					</ion-item>
					}
				</ion-item-group>
				}
			</ion-list>
		</ion-content>
	</ng-template>
</ion-modal>
